class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    
    if (document.querySelector('#FacetFiltersFormMobile .range__price-min')) FacetFiltersForm.loadPriceRangeMobile();
    if (document.querySelector('.facets-type-vertical')) FacetFiltersForm.loadPriceRangeSidebar();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    document.querySelectorAll('collection-infinite-scroll').forEach((loader) => loader.cancel?.());
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    initializeDimensionRanges();
    sizeCollectionSortControls();
    if (document.querySelector('#FacetFiltersFormMobile .range__price-min')) FacetFiltersForm.loadPriceRangeMobile();
    if (document.querySelector('.facets-type-vertical')) FacetFiltersForm.loadPriceRangeSidebar();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  static loadPriceRangeSidebar() {
    const inputValueMin = document.querySelector("#FacetFiltersForm .input__price-min");
    const inputValueMax = document.querySelector("#FacetFiltersForm .input__price-max");
    const slideValueMin = document.querySelector("#FacetFiltersForm .range__price-min");
    const slideValueMax = document.querySelector("#FacetFiltersForm .range__price-max");
    const thumbLeft = document.querySelector("#FacetFiltersForm .slider > .thumb.left");
    const thumbRight = document.querySelector("#FacetFiltersForm .slider > .thumb.right");
    const range = document.querySelector("#FacetFiltersForm .slider > .range");

    FacetFiltersForm.updatePriceRangeFilter(inputValueMin, inputValueMax, slideValueMin, slideValueMax, thumbLeft, thumbRight, range);
  }

  static loadPriceRangeMobile() {
    const inputValueMin = document.querySelector("#FacetFiltersFormMobile .input__price-min");
    const inputValueMax = document.querySelector("#FacetFiltersFormMobile .input__price-max");
    const slideValueMin = document.querySelector("#FacetFiltersFormMobile .range__price-min");
    const slideValueMax = document.querySelector("#FacetFiltersFormMobile .range__price-max");
    const thumbLeft = document.querySelector("#FacetFiltersFormMobile .slider > .thumb.left");
    const thumbRight = document.querySelector("#FacetFiltersFormMobile .slider > .thumb.right");
    const range = document.querySelector("#FacetFiltersFormMobile .slider > .range");
    FacetFiltersForm.updatePriceRangeFilter(inputValueMin, inputValueMax, slideValueMin, slideValueMax, thumbLeft, thumbRight, range);
  }

  static updatePriceRangeFilter(inputValueMin, inputValueMax, slideValueMin, slideValueMax, thumbLeft, thumbRight, range) {
    if (![inputValueMin, inputValueMax, slideValueMin, slideValueMax, thumbLeft, thumbRight, range].every(Boolean)) return;
    FacetFiltersForm.setLeftValuePriceRange(slideValueMin, slideValueMax, inputValueMin, thumbLeft, range, false);
    FacetFiltersForm.setRightValuePriceRange(slideValueMax, slideValueMin, inputValueMax, thumbRight, range, false);

    const context = this;
    
    slideValueMin.addEventListener("input", (e) => {
      e.preventDefault();
      context.setLeftValuePriceRange(slideValueMin, slideValueMax, inputValueMin, thumbLeft, range, true);
    });
    slideValueMax.addEventListener("input", (e) => {
      e.preventDefault();
      context.setRightValuePriceRange(slideValueMax, slideValueMin, inputValueMax, thumbRight, range, true);
    });

    inputValueMin.addEventListener("input", function (e) {
      slideValueMin.value = e.target.value || 0;
      context.setLeftValuePriceRange(slideValueMin, slideValueMax, inputValueMin, thumbLeft, range, true);
    });

    inputValueMax.addEventListener("input", function (e) {
      slideValueMax.value = e.target.value || 0;
      context.setRightValuePriceRange(slideValueMax, slideValueMin, inputValueMax, thumbRight, range, true);
    });

    slideValueMin.addEventListener("mouseover", function() {
      thumbLeft.classList.add("hover");
    });
    slideValueMin.addEventListener("mouseout", function() {
      thumbLeft.classList.remove("hover");
    });
    slideValueMin.addEventListener("mousedown", function() {
      thumbLeft.classList.add("active");
    });
    slideValueMin.addEventListener("mouseup", function() {
      thumbLeft.classList.remove("active");
    });

    slideValueMax.addEventListener("mouseover", function() {
      thumbRight.classList.add("hover");
    });
    slideValueMax.addEventListener("mouseout", function() {
      thumbRight.classList.remove("hover");
    });
    slideValueMax.addEventListener("mousedown", function() {
      thumbRight.classList.add("active");
    });
    slideValueMax.addEventListener("mouseup", function() {
      thumbRight.classList.remove("active");
    });
  }

  static setLeftValuePriceRange(slideValueMin, slideValueMax, inputValueMin, thumbLeft, range, inputChanged) {
    const _this = slideValueMin;
    const min = parseInt(_this.min);
    const max = parseInt(_this.max);
    const value = Math.min(parseInt(_this.value || 0), parseInt(slideValueMax.value) - 1);

    _this.value = value;
    if (inputChanged) {
      inputValueMin.value = value;
    }

    const percent = ((_this.value - min) / (max - min)) * 100;

    thumbLeft.style.left = percent + "%";
    range.style.left = percent + "%";
  }

  static setRightValuePriceRange(slideValueMax, slideValueMin, inputValueMax, thumbRight, range, inputChanged) {
    const _this = slideValueMax;
    const min = parseInt(_this.min);
    const max = parseInt(_this.max);

    _this.value = Math.max(parseInt(_this.value), parseInt(slideValueMin.value || 0) + 1);
    if (inputChanged) {
      inputValueMax.value = Math.max(parseInt(_this.value), parseInt(slideValueMin.value || 0) + 1);
    }

    const percent = ((_this.value - min) / (max - min)) * 100;

    thumbRight.style.right = (100 - percent) + "%";
    range.style.right = (100 - percent) + "%";
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


// Keep Shopify's existing list parameters: a range selects every registered value between its limits.
function initializeDimensionRanges() {
  document.querySelectorAll('[data-dimension-filter]').forEach((details) => {
    const list = details.querySelector('ul');
    if (!list || list.dataset.dimensionReady) return;
    details.querySelector('.dimension-range')?.remove();
    const options = Array.from(list.querySelectorAll('input[type="checkbox"]')).map((input) => {
      const label = input.closest('label')?.querySelector('.facet-checkbox__text-label')?.textContent.trim() || '';
      const match = label.match(/^(\d+(?:[.,]\d+)?)\s*(mm|cm|m)?$/i);
      return { input, label, value: match ? Number(match[1].replace(',', '.')) : NaN, unit: match?.[2]?.toLowerCase() || '' };
    });
    // Composite sizes and mixed units retain their original, unambiguous checkbox UI.
    if (options.length < 2 || options.some((option) => !Number.isFinite(option.value)) ||
        new Set(options.map((option) => option.unit)).size > 1) return;
    options.sort((a, b) => a.value - b.value);
    const values = [...new Set(options.map((option) => option.value))];
    if (values.length < 2) return;
    const active = options.filter((option) => option.input.checked);
    // Preserve externally linked non-contiguous selections without changing their meaning.
    if (active.length && options.some((option) => !option.input.checked && option.value > active[0].value && option.value < active[active.length - 1].value)) return;
    const control = document.createElement('div');
    control.className = 'dimension-range';
    const title = details.querySelector('summary span')?.textContent.trim() || 'Medidas';
    const endpoints = ['De', 'Para'].map((caption, index) => {
      const label = document.createElement('label');
      const text = document.createElement('span');
      text.textContent = caption;
      const field = document.createElement('div');
      field.className = 'dimension-range__field';
      const output = document.createElement('input');
      output.type = 'text';
      output.inputMode = 'decimal';
      output.id = `${details.id}-dimension-value-${index}`;
      output.setAttribute('aria-label', `${title}: ${caption.toLowerCase()}`);
      label.htmlFor = output.id;
      const unit = document.createElement('span');
      unit.textContent = options[0].unit;
      field.append(output, unit);
      const input = document.createElement('input');
      input.type = 'range';
      input.className = index ? 'dimension-range__max' : 'dimension-range__min';
      input.min = 0;
      input.max = values.length - 1;
      input.step = 1;
      input.setAttribute('aria-label', `${title}: ${caption.toLowerCase()}`);
      input.value = active.length ? values.indexOf(index ? active[active.length - 1].value : active[0].value) : index ? values.length - 1 : 0;
      label.append(text, field);
      control.append(label, input);
      return { input, output };
    });
    const update = (changed) => {
      const [min, max] = endpoints.map((endpoint) => Number(endpoint.input.value));
      if (min > max) endpoints[changed === 0 ? 1 : 0].input.value = changed === 0 ? min : max;
      const bounds = endpoints.map((endpoint) => values[Number(endpoint.input.value)]);
      endpoints.forEach((endpoint, index) => {
        endpoint.output.value = String(bounds[index]).replace('.', ',');
        endpoint.output.style.width = `${Math.max(1, endpoint.output.value.length)}ch`;
        endpoint.input.setAttribute('aria-valuetext', options.find((option) => option.value === bounds[index]).label);
      });
      if (changed === undefined) return;
      const fullRange = bounds[0] === values[0] && bounds[1] === values[values.length - 1];
      options.forEach((option) => { option.input.checked = !fullRange && option.value >= bounds[0] && option.value <= bounds[1]; });
    };
    endpoints.forEach((endpoint, index) => {
      endpoint.input.addEventListener('input', () => update(index));
      endpoint.output.addEventListener('input', event => {
        event.stopPropagation();
        endpoint.output.style.width = `${Math.max(1, endpoint.output.value.length)}ch`;
      });
      const commit = () => {
        const typed = endpoint.output.value.trim().replace(',', '.');
        const value = typed === '' ? values[index ? values.length - 1 : 0] : Number(typed);
        if (!Number.isFinite(value)) { update(); return; }
        const closest = values.reduce((best, candidate, position) =>
          Math.abs(candidate - value) < Math.abs(values[best] - value) ? position : best, 0);
        endpoint.input.value = closest;
        update(index);
        endpoint.input.dispatchEvent(new Event('input', { bubbles: true }));
      };
      endpoint.output.addEventListener('change', commit);
      endpoint.output.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); commit(); }
      });
    });
    update();
    list.before(control);
    list.hidden = true;
    list.dataset.dimensionReady = 'true';
  });
}
initializeDimensionRanges();


// Native selects otherwise reserve the width of their longest option.
function sizeCollectionSortControls() {
  const context = document.createElement('canvas').getContext('2d');
  if (!context) return;
  document.querySelectorAll('.facet-filters .facet-filters__sort').forEach((select) => {
    const style = getComputedStyle(select);
    context.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
    const text = select.selectedOptions[0]?.textContent.trim() || '';
    const spacing = (parseFloat(style.letterSpacing) || 0) * text.length;
    const padding = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
    select.style.width = `${Math.ceil(context.measureText(text).width + spacing + padding + 2)}px`;
  });
}
sizeCollectionSortControls();
document.fonts?.ready.then(sizeCollectionSortControls);
document.addEventListener('change', (event) => {
  if (event.target.matches('.facet-filters__sort')) sizeCollectionSortControls();
});
